import React, { useContext } from 'react';
import './compare.css';
import DoneIcon from '@mui/icons-material/Done';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { MyContext } from '../../context';

function Compare() {
  const { pageData } = useContext(MyContext);

  return (
    <section className="compare-Wrap">
      <div className="compare-Wrap container">
        <div>
          <h2 className="compare-wrap-header">
            {pageData?.comparePage?.header}
          </h2>
          <p className="compare-wrap-desc">{pageData?.comparePage?.subTitle}</p>
        </div>
        <div className="compare-wrap-table">
          <div className="compare-left-section">
            <h6> {pageData?.comparePage?.wiseDrivePoints?.header}</h6>
            {pageData?.comparePage?.wiseDrivePoints?.content?.map(
              (point, index) => (
                <span className="compare-span-css">
                  <DoneIcon className="doneIconCompare" />
                  {point?.point}
                </span>
              )
            )}
          </div>
          <div className="compare-right-section">
            <h6> {pageData?.comparePage?.comparePoints?.header}</h6>
            {pageData?.comparePage?.comparePoints?.content?.map(
              (point, index) => (
                <span className="compare-span-css">
                  <RemoveCircleOutlineIcon className="removeIconCompare" />
                  {point?.point}
                </span>
              )
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Compare;
